import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, FlaskConical, ReceiptText } from 'lucide-react';
import InactivityTimer from '../../components/InactivityTimer';

const ReportsAndBills = () => {
    const options = [
        {
            to: '/lab-reports',
            title: 'Lab Reports',
            description: 'View, download or share your laboratory reports.',
            icon: FlaskConical,
        },
        {
            to: '/radiology-reports',
            title: 'Radiology Reports',
            description: 'Access your radiology and imaging reports.',
            icon: FileText,
        },
        {
            to: '/billing',
            title: 'Bills & Invoices',
            description: 'View and download your hospital bills and invoices.',
            icon: ReceiptText,
        },
    ];

    return (
        <>
            <InactivityTimer />
            <main className="min-h-screen bg-gray-50 px-4 pb-10 pt-8 sm:px-8">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-8 flex items-center gap-4">
                        <Link
                            to="/dashboard"
                            className="inline-flex items-center gap-2 rounded-lg bg-[#0FA968] px-4 py-2.5 font-semibold text-white hover:bg-[#138F5E]"
                        >
                            <ArrowLeft className="h-5 w-5" />
                            Back
                        </Link>
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">
                                Reports & Bills
                            </h1>
                            <p className="mt-1 text-sm text-gray-600 sm:text-base">
                                Select the information you want to access.
                            </p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
                        {options.map(({ to, title, description, icon: Icon }) => (
                            <Link
                                key={to}
                                to={to}
                                className="group rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
                            >
                                <div className="mb-5 inline-flex rounded-2xl bg-emerald-50 p-4 text-[#0FA968] group-hover:bg-[#0FA968] group-hover:text-white">
                                    <Icon className="h-9 w-9" />
                                </div>
                                <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
                                <p className="mt-2 text-sm leading-6 text-gray-600">{description}</p>
                            </Link>
                        ))}
                    </div>
                </div>
            </main>
        </>
    );
};

export default ReportsAndBills;
